export const Bonds = {
    "AE000A2K9H64": {
        "bondName": "United Arab Emirates Sukuk 4.30% 19-Jun-2029",
        "endDate": "2029-06-19",
        "coupon": 4.3,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "AED",
        "accruedInterest": 0
    },
    "AE000A2K9H72": {
        "bondName": "United Arab Emirates Sukuk 4.15% 19-Jun-2031",
        "endDate": "2031-06-19",
        "coupon": 4.15,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "AED",
        "accruedInterest": 0
    },
    "AE000TB12M25": {
        "bondName": "United Arab Emirates Treasury Bill 0% 12M",
        "endDate": "2025-12-18",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "AED",
        "accruedInterest": 0
    },
    "AE000TB3M25": {
        "bondName": "United Arab Emirates Treasury Bill 0% 3M",
        "endDate": "2025-03-18",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "AED",
        "accruedInterest": 0
    },
    "AE000TB6M25": {
        "bondName": "United Arab Emirates Treasury Bill 0% 6M",
        "endDate": "2025-06-18",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "AED",
        "accruedInterest": 0
    },
    "BH000A0TCKE3": {
        "bondName": "Kingdom of Bahrain Sukuk Al Salam 3.75% 21-Oct-2024",
        "endDate": "2024-10-21",
        "coupon": 3.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000A0U1MS4": {
        "bondName": "Kingdom of Bahrain Ijarah Sukuk 4.25% 08-Mar-2028",
        "endDate": "2028-03-08",
        "coupon": 4.25,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000A0Z8FJ3": {
        "bondName": "Bahrain Development Bond BHD 6.25% 2028",
        "endDate": "2028-11-15",
        "coupon": 6.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000A0Z9GK8": {
        "bondName": "Bahrain Development Bond BHD 7.00% 2032",
        "endDate": "2032-03-01",
        "coupon": 7.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000TB091D": {
        "bondName": "Kingdom of Bahrain Treasury Bill 0% 91D",
        "endDate": "2025-02-02",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000TB182D": {
        "bondName": "Kingdom of Bahrain Treasury Bill 0% 182D",
        "endDate": "2025-05-05",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "BH000TB364D": {
        "bondName": "Kingdom of Bahrain Treasury Bill 0% 364D",
        "endDate": "2025-11-04",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "BHD",
        "accruedInterest": 0
    },
    "KW000A0Z7H12": {
        "bondName": "Kuwait Government Bond KWD 3.00% 2027",
        "endDate": "2027-09-30",
        "coupon": 3.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW000A0Z8J45": {
        "bondName": "Kuwait Government Bond KWD 3.50% 2031",
        "endDate": "2031-09-30",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW000TB12M25": {
        "bondName": "State of Kuwait Treasury Bill 0% 12M",
        "endDate": "2025-12-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW000TB3M25": {
        "bondName": "State of Kuwait Treasury Bill 0% 3M",
        "endDate": "2025-03-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW000TB6M25": {
        "bondName": "State of Kuwait Treasury Bill 0% 6M",
        "endDate": "2025-06-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW0DI0000482": {
        "bondName": "Kuwait Bonds 4.625% 02-Aug-2028 (Local currency)",
        "endDate": "2028-08-02",
        "coupon": 4.625,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW0DI0000508": {
        "bondName": "Kuwait Bonds 5.125% 25-Aug-2032 (Local currency)",
        "endDate": "2032-08-25",
        "coupon": 5.125,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "KW0DI0000516": {
        "bondName": "Kuwait Bonds 5.375% 29-Aug-2035 (Local currency)",
        "endDate": "2035-08-29",
        "coupon": 5.375,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "KWD",
        "accruedInterest": 0
    },
    "OM0000000277": {
        "bondName": "Sultanate of Oman Sovereign Sukuk 5.70% 01-May-2027",
        "endDate": "2027-05-01",
        "coupon": 5.7,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OM0000000285": {
        "bondName": "Sultanate of Oman Government Bond OMR 4.75% 2028",
        "endDate": "2028-03-01",
        "coupon": 4.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OM0000000301": {
        "bondName": "Sultanate of Oman Sovereign Sukuk 6.00% 01-May-2030",
        "endDate": "2030-05-01",
        "coupon": 6.0,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OM0000000319": {
        "bondName": "Sultanate of Oman Government Bond OMR 5.00% 2031",
        "endDate": "2031-03-01",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OM0000000350": {
        "bondName": "Sultanate of Oman Government Bond OMR 5.50% 2035",
        "endDate": "2035-03-01",
        "coupon": 5.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OMTB00009125": {
        "bondName": "Sultanate of Oman Treasury Bill 0% 91D",
        "endDate": "2025-03-20",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OMTB00018225": {
        "bondName": "Sultanate of Oman Treasury Bill 0% 182D",
        "endDate": "2025-06-19",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "OMTB00036425": {
        "bondName": "Sultanate of Oman Treasury Bill 0% 364D",
        "endDate": "2025-12-18",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "OMR",
        "accruedInterest": 0
    },
    "QA0003YFQA89": {
        "bondName": "QCB (on behalf of State) Bond 4.75% 15-Apr-2029 (GA70)",
        "endDate": "2029-04-15",
        "coupon": 4.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA0004WH6095": {
        "bondName": "QCB (on behalf of State) Bond 5.00% 15-Apr-2031 (GA71)",
        "endDate": "2031-04-15",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000A0Z9HJ7": {
        "bondName": "Qatar Government Bond QAR 4.00% 2029",
        "endDate": "2029-06-30",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000A0Z9HK5": {
        "bondName": "Qatar Government Bond QAR 4.50% 2034",
        "endDate": "2034-06-30",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000D836SM1": {
        "bondName": "QCB (on behalf of State) Bond 5.00% 15-Apr-2026 (GA68)",
        "endDate": "2026-04-15",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000K258HB5": {
        "bondName": "State of Qatar Government Sukuk 4.10% 22-Sep-2026",
        "endDate": "2026-09-22",
        "coupon": 4.1,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000N1I38N9": {
        "bondName": "QCB (on behalf of State) Bond 4.80% 15-Apr-2027 (GA69)",
        "endDate": "2027-04-15",
        "coupon": 4.8,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000TB091D": {
        "bondName": "State of Qatar Treasury Bill 0% 91D",
        "endDate": "2025-01-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000TB182D": {
        "bondName": "State of Qatar Treasury Bill 0% 182D",
        "endDate": "2025-04-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA000TB273D": {
        "bondName": "State of Qatar Treasury Bill 0% 273D",
        "endDate": "2025-07-30",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "QA0035210061": {
        "bondName": "State of Qatar Government Sukuk 4.75% 15-Apr-2029",
        "endDate": "2029-04-15",
        "coupon": 4.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "QAR",
        "accruedInterest": 0
    },
    "SA000A1X6DL6": {
        "bondName": "Kingdom of Saudi Arabia Sukuk 4.00% 15-Jan-2027",
        "endDate": "2027-01-15",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1X6DM4": {
        "bondName": "Kingdom of Saudi Arabia Sukuk 4.30% 18-Apr-2029",
        "endDate": "2029-04-18",
        "coupon": 4.3,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1X6DN2": {
        "bondName": "Kingdom of Saudi Arabia Sukuk 4.75% 19-Feb-2033",
        "endDate": "2033-02-19",
        "coupon": 4.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1Z6F10": {
        "bondName": "KSA Government Bond SAR 2.90% 2028",
        "endDate": "2028-01-15",
        "coupon": 2.9,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1Z7D45": {
        "bondName": "KSA Government Bond SAR 3.20% 2030",
        "endDate": "2030-01-15",
        "coupon": 3.2,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1Z8E23": {
        "bondName": "KSA Government Bond SAR 4.00% 2035",
        "endDate": "2035-07-20",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000A1Z9G45": {
        "bondName": "KSA Government Bond SAR 3.75% 2040",
        "endDate": "2040-07-15",
        "coupon": 3.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000TB091D": {
        "bondName": "Kingdom of Saudi Arabia Treasury Bill 0% 91D",
        "endDate": "2025-02-05",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000TB182D": {
        "bondName": "Kingdom of Saudi Arabia Treasury Bill 0% 182D",
        "endDate": "2025-05-08",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "SA000TB364D": {
        "bondName": "Kingdom of Saudi Arabia Treasury Bill 0% 364D",
        "endDate": "2025-11-06",
        "coupon": 0.0,
        "couponFrequency": 0,
        "couponCalcMethod": "T-Bill",
        "ccy": "SAR",
        "accruedInterest": 0
    },
    "XS1188112345": {
        "bondName": "Ahli United Bank Sukuk 3.50% 16-Feb-2026",
        "endDate": "2026-02-16",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1195572077": {
        "bondName": "National Bank of Kuwait Bond 3.50% 27-Feb-2026",
        "endDate": "2026-02-27",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1200958518": {
        "bondName": "Qatar Islamic Bank Sukuk 3.40% 25-Mar-2026",
        "endDate": "2026-03-25",
        "coupon": 3.4,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1405781854": {
        "bondName": "State of Qatar Bond 4.625% 02-Jun-2046 (Reg S)",
        "endDate": "2046-06-02",
        "coupon": 4.625,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1439818906": {
        "bondName": "Emirates NBD Bond 3.25% 16-Jun-2026",
        "endDate": "2026-06-16",
        "coupon": 3.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1439819276": {
        "bondName": "Qatar National Bank Bond 3.25% 20-Jun-2026",
        "endDate": "2026-06-20",
        "coupon": 3.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1504781145": {
        "bondName": "Kuwait Finance House Bond 3.25% 06-Nov-2026",
        "endDate": "2026-11-06",
        "coupon": 3.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1523799350": {
        "bondName": "Industries Qatar Sukuk 3.15% 30-Sep-2025",
        "endDate": "2025-09-30",
        "coupon": 3.15,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1550741321": {
        "bondName": "National Bank of Kuwait Bond 4.50% 30-Jan-2028",
        "endDate": "2028-01-30",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1551254381": {
        "bondName": "First Abu Dhabi Bank Bond 3.00% 20-Jan-2027",
        "endDate": "2027-01-20",
        "coupon": 3.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1575968021": {
        "bondName": "Sultanate of Oman Bond 5.75% 31-Jan-2047",
        "endDate": "2047-01-31",
        "coupon": 5.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1584567640": {
        "bondName": "Kingdom of Bahrain Bond 7.375% 14-May-2026",
        "endDate": "2026-05-14",
        "coupon": 7.375,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1585962501": {
        "bondName": "State of Kuwait Bond 2.75% 20-Mar-2022",
        "endDate": "2022-03-20",
        "coupon": 2.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1585962683": {
        "bondName": "State of Kuwait Bond 3.50% 20-Mar-2027",
        "endDate": "2027-03-20",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1585962840": {
        "bondName": "State of Kuwait Bond 4.00% 20-Mar-2032",
        "endDate": "2032-03-20",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1585962923": {
        "bondName": "State of Kuwait Bond 4.50% 20-Mar-2047",
        "endDate": "2047-03-20",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1611154020": {
        "bondName": "Sultanate of Oman Bond 7.00% 26-Jan-2027",
        "endDate": "2027-01-26",
        "coupon": 7.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1653814739": {
        "bondName": "Oman Oil Company Bond 6.00% 02-Aug-2027",
        "endDate": "2027-08-02",
        "coupon": 6.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1681042990": {
        "bondName": "Kingdom of Bahrain Bond 7.50% 19-Sep-2047",
        "endDate": "2047-09-19",
        "coupon": 7.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1705678901": {
        "bondName": "SABIC Bond 4.00% 21-Sep-2027",
        "endDate": "2027-09-21",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1757142797": {
        "bondName": "Sultanate of Oman Bond 6.75% 08-Mar-2028",
        "endDate": "2028-03-08",
        "coupon": 6.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1786209984": {
        "bondName": "Abu Dhabi Commercial Bank Bond 3.50% 12-Mar-2028",
        "endDate": "2028-03-12",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1807281234": {
        "bondName": "Gulf Bank Bond 4.00% 23-Mar-2027",
        "endDate": "2027-03-23",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1843437037": {
        "bondName": "Sultanate of Oman Bond 6.00% 25-Oct-2032",
        "endDate": "2032-10-25",
        "coupon": 6.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1931226065": {
        "bondName": "Sultanate of Oman Sovereign Sukuk 5.50% 08-Jan-2029",
        "endDate": "2029-01-08",
        "coupon": 5.5,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1957653210": {
        "bondName": "Kingdom of Saudi Arabia Bond 2.875% 12-Apr-2026",
        "endDate": "2026-04-12",
        "coupon": 2.875,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1959337152": {
        "bondName": "Commercial Bank of Qatar Bond 4.00% 14-Mar-2029",
        "endDate": "2029-03-14",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1959337582": {
        "bondName": "State of Qatar Bond 4.00% 14-Mar-2029 (Reg S)",
        "endDate": "2029-03-14",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1959337749": {
        "bondName": "State of Qatar Bond 4.817% 14-Mar-2049 (Reg S)",
        "endDate": "2049-03-14",
        "coupon": 4.817,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1959338126": {
        "bondName": "DP World Sukuk 3.75% 31-Jan-2030",
        "endDate": "2030-01-31",
        "coupon": 3.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1963456789": {
        "bondName": "Bank Muscat Bond 4.25% 12-Mar-2028",
        "endDate": "2028-03-12",
        "coupon": 4.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1982113464": {
        "bondName": "Saudi Aramco Bond 3.50% 16-Apr-2029",
        "endDate": "2029-04-16",
        "coupon": 3.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS1987654321": {
        "bondName": "Qatar Islamic Bank Green Sukuk 3.00% 19-Oct-2026",
        "endDate": "2026-10-19",
        "coupon": 3.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2010020705": {
        "bondName": "Kingdom of Bahrain Bond 6.75% 20-Sep-2029",
        "endDate": "2029-09-20",
        "coupon": 6.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2010043900": {
        "bondName": "Kingdom of Saudi Arabia Bond 3.25% 22-Jan-2030",
        "endDate": "2030-01-22",
        "coupon": 3.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2012345678": {
        "bondName": "Boubyan Bank Bond 3.875% 21-Oct-2028",
        "endDate": "2028-10-21",
        "coupon": 3.875,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2100291238": {
        "bondName": "Doha Bank Bond 4.50% 20-Jan-2028",
        "endDate": "2028-01-20",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2100293341": {
        "bondName": "Emaar Properties Sukuk 4.00% 15-Jun-2029",
        "endDate": "2029-06-15",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2100294562": {
        "bondName": "Saudi Electricity Company Sukuk 4.00% 20-Jan-2028",
        "endDate": "2028-01-20",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2108456789": {
        "bondName": "Al Rayan Bank Bond 3.75% 21-Jan-2026",
        "endDate": "2026-01-21",
        "coupon": 3.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2109876543": {
        "bondName": "Bank Muscat Sukuk 4.50% 05-Nov-2029",
        "endDate": "2029-11-05",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2120891777": {
        "bondName": "Kingdom of Bahrain Bond 7.00% 12-Jan-2030",
        "endDate": "2030-01-12",
        "coupon": 7.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2134103125": {
        "bondName": "National Bank of Bahrain Bond 4.50% 30-Mar-2027",
        "endDate": "2027-03-30",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2155352748": {
        "bondName": "State of Qatar Bond 4.40% 16-Apr-2050 (Reg S)",
        "endDate": "2050-04-16",
        "coupon": 4.4,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2211441234": {
        "bondName": "Bank ABC Bond 4.875% 05-Jul-2026",
        "endDate": "2026-07-05",
        "coupon": 4.875,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2234567890": {
        "bondName": "QNB Green Bond 1.875% 15-Sep-2025",
        "endDate": "2025-09-15",
        "coupon": 1.875,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2254321098": {
        "bondName": "OQ Sukuk 5.00% 08-Jul-2030",
        "endDate": "2030-07-08",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2292748025": {
        "bondName": "Sultanate of Oman Bond 6.25% 02-Feb-2031",
        "endDate": "2031-02-02",
        "coupon": 6.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2298712345": {
        "bondName": "Kingdom of Saudi Arabia Bond 4.00% 22-Jan-2041",
        "endDate": "2041-01-22",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2298743210": {
        "bondName": "Riyad Bank Sukuk 3.75% 21-Mar-2027",
        "endDate": "2027-03-21",
        "coupon": 3.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2298765432": {
        "bondName": "Gulf International Bank Sukuk 4.25% 20-Sep-2028",
        "endDate": "2028-09-20",
        "coupon": 4.25,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2345612345": {
        "bondName": "Al Rayan Bank Bond 4.00% 18-May-2028",
        "endDate": "2028-05-18",
        "coupon": 4.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2345678901": {
        "bondName": "Oman Sovereign Wealth Fund (OIA) Bond 5.50% 18-Jun-2031",
        "endDate": "2031-06-18",
        "coupon": 5.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2362939982": {
        "bondName": "Saudi National Bank Bond 3.25% 27-Oct-2026",
        "endDate": "2026-10-27",
        "coupon": 3.25,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2533722388": {
        "bondName": "United Arab Emirates Bond 4.951% 07-Oct-2034",
        "endDate": "2034-10-07",
        "coupon": 4.951,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2533722461": {
        "bondName": "United Arab Emirates Bond 4.763% 07-Oct-2052",
        "endDate": "2052-10-07",
        "coupon": 4.763,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2537852355": {
        "bondName": "Sultanate of Oman Sovereign Sukuk 5.75% 27-Oct-2032",
        "endDate": "2032-10-27",
        "coupon": 5.75,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2578912345": {
        "bondName": "Lesha Bank Bond 5.00% 15-Nov-2027",
        "endDate": "2027-11-15",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2578927895": {
        "bondName": "Kingdom of Saudi Arabia Bond 4.50% 22-Jan-2033",
        "endDate": "2033-01-22",
        "coupon": 4.5,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2578930212": {
        "bondName": "Kingdom of Saudi Arabia Bond 5.00% 16-Jan-2053",
        "endDate": "2053-01-16",
        "coupon": 5.0,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2738526334": {
        "bondName": "Kingdom of Saudi Arabia Bond 4.75% 16-Feb-2036",
        "endDate": "2036-02-16",
        "coupon": 4.75,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS2822506759": {
        "bondName": "State of Qatar Bond 4.625% 29-May-2029 (Reg S)",
        "endDate": "2029-05-29",
        "coupon": 4.625,
        "couponFrequency": 2,
        "couponCalcMethod": "European 30/360",
        "ccy": "USD",
        "accruedInterest": 0
    },
    "XS3076272130": {
        "bondName": "AlRayan Bank Q.P.S.C Sukuk 4.875% 2030-05-29",
        "endDate": "2030-05-29",
        "coupon": 4.875,
        "couponFrequency": 2,
        "couponCalcMethod": "Islamic (Sukuk)",
        "ccy": "USD",
        "accruedInterest": 0
    }
}
